import { DrillDownEvent, ParamsDrillDownEvent } from "../types"

export class ListDrillDownEvent{

    events: DrillDownEvent[]

    constructor(events: DrillDownEvent[] = []){
        this.events = events
    }

    public getByLookup(event: DrillDownEvent, lookup: string){
        return event.params.find(param => param.lookup === lookup)
    }
}